import React from 'react';
import styled, {css} from 'styled-components';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

import Header from "./Header";
import Company from "./Company";
import Solutions from "./Solutions";
import Footer from "./Footer";
import Details from "./Details";

let DIV = styled.div`
  /* background-color: #282c34; */
  background-color: #FFFFFF;
  color: #4d5256;
      
  font-family: 'Merriweather Sans', sans-serif;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-style: normal;
  
  /* a 태그에서 기본 컬러 사용 안하고 데코레이션도 제거 */
  a {
    color: inherit;
    text-decoration: none;
  }
  
  /* 폰트 추가 */
  @import url('https://fonts.googleapis.com/css?family=Merriweather+Sans|Montserrat|Noto+Sans+KR&display=swap');
  @import url(//spoqa.github.io/spoqa-han-sans/css/SpoqaHanSans-jp.css);
  
  /* 백그라운드 이미지 테스트 중, 초기화면에서 본 이미지가 화면을 꽉채워서 보기 좋게 하는 용도.
  min-height: 100vh;
  background-image: url("/images/greeting_stairs.jpeg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  */

`;

function App() {
  return (
    <Router>
      <DIV className="App">
        <Header/>
        <Switch>
          <Route exact path="/">
            <Company />
          </Route>
          <Route exact path="/home">
            <Company />
          </Route>
          <Route path="/solutions">
            <Solutions />
          </Route>
          <Route path="/details/:key" component={Details} />
        </Switch>
        <Footer/>
      </DIV>
    </Router>
  );
}

export default App;
